import { dashboardSelectList } from '@/modules/dashboard/dashboardActions';
import { useDispatch } from 'react-redux';

export const useSelectListMutation = () => {
	const dispatch = useDispatch();

	const mutate = (listId: string) => {
		dispatch(dashboardSelectList(listId));
	};

	return { mutate };
};
